<template>
  <div class="animated fadeIn row">
    <div class="card w-full">
      <div class="card-header">
        <strong><span v-bind:class="'flag-icon flag-icon-us'" v-if="data.promotion.lang=='en'"></span><span v-bind:class="'flag-icon flag-icon-'+data.promotion.lang"
            v-if="data.promotion.lang!='en'"></span> บทความ : {{data.promotion.title}}</strong>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <label v-if="data.promotion.created_at">&nbsp;&nbsp;<b>วันที่สร้าง:</b> {{ data.promotion.created_at |
                moment('timezone', 'Asia/Bangkok', 'LLLL')}}</label>
              <label v-if="data.promotion.updated_at">&nbsp;&nbsp;<b>วันที่แก้ไข:</b> {{ data.promotion.updated_at |
                moment('timezone', 'Asia/Bangkok', 'LLLL')}}</label>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="form-group row" v-if="data.promotion.image!=''">
            <div class="offset-lg-1 col-lg-10 text-center">
              <img v-bind:src="data.promotion.image" class="d-block w-full" @error="imageLoadError">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <p v-html="data.promotion.content"></p>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="offset-lg-4 col-lg-4">
            <router-link :to="{ name: 'PromotionList'}"><button class="btn btn-info w-full" type="button"><i class="far fa-newspaper"></i>
                ดูโปรโมชั่นอื่นๆ</button></router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueMoment from 'vue-moment'
  import moment from 'moment-timezone'
  Vue.use(VueMoment, {
    moment,
  })
  export default {
    data() {
      return {
        load: 0,
        promotion: {
          id: parseInt(this.$route.query.id)
        },
        no_image:{
          src: 'https://d2gvpkbpfjsf4i.cloudfront.net/web-builder/no-image.png'
        },
        authorization: 'Bearer '+localStorage.getItem('z_token'),
        data: {
          promotion: {
            title: '',
            image: '',
            content: '',
            lang: 'th',
            created_at: '',
            updated_at: ''
          }
        }
      }
    },
    methods: {
      checkLoad() {
        this.load = this.load - 1
        if (this.load <= 0) {
          this.load = 0
          this.$Progress.finish()
        }
      },
      startLoad(count) {
        this.load = count
        this.$Progress.start()
      },
      failLoad() {
        this.$Progress.fail()
      },
      getPromotionByID(id) {
        this.startLoad(1)
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/promotion/' + id, {
          params: {
            lang: this.data.promotion.lang
          },
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.checkLoad()
          if (response.body.json) {
            this.data.promotion.title = response.body.json.title
            this.data.promotion.content = response.body.json.description
            this.data.promotion.image = response.body.json.image
            this.data.promotion.lang = response.body.json.locale
            this.data.promotion.created_at = response.body.json.created_at
            this.data.promotion.updated_at = response.body.json.updated_at
            moment.locale(this.data.promotion.lang)
          }
        }, response => {
          this.failLoad()
        })

      },
      imageLoadError(event){
        this.data.promotion.image = ''
        event.target.src = this.no_image.src
      }
    },
    mounted() {
      if (Number.isInteger(this.promotion.id)) {
        this.getPromotionByID(this.promotion.id)
      }
    }
  }

</script>
